

/* tslint:disable */



export enum ConcurrencyChangeType {
    None = 0,
    State = 1,
    Version = 2,
    Content = 3,

}


